module.exports = __webpack_public_path__ + "static/media/IMG_2655.f3b427ce.JPG";